import { useEffect, useState } from 'react';
import { Modal } from '@app/shared';
import { FeedBackAsync, FeedBackAutoAsync, FeedBackBatteryAsync } from './modal';
import classNames from 'classnames';

import styles from './feedBackGlobal.module.scss';

export enum TemplateFeedback {
  Primary = 'Primary',
  Auto = 'Auto',
  Battery = 'Battery',
}

export type OptionsType = {
  template?: TemplateFeedback;
  sectionName?: string;
  isClosingAfterSending?: boolean;
  isBtnClosing?: boolean;
  isRequiredMessage?: boolean;
  isBackground?: boolean;
  titleModal?: string;
  btnText?: string;
  callBackOpen?: () => void;
  callBackClose?: () => void;
};

const keyOptions: OptionsType = {
  sectionName: '',
  isClosingAfterSending: true,
  isBtnClosing: true,
  isRequiredMessage: true,
  isBackground: true,
  titleModal: '',
  btnText: '',
  callBackOpen: null,
  callBackClose: null,
};

export const FeedBackGlobal = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [settings, setSettings] = useState<OptionsType>({
    isClosingAfterSending: true,
    isRequiredMessage: true,
    isBackground: true,
    isBtnClosing: true,
    template: TemplateFeedback.Primary,
  });
  const handlerOpen = (options: OptionsType) => {
    options && setSettings({ ...settings, ...options });
    options.callBackOpen && options.callBackOpen();
    setOpen(true);
  };

  const handlerClose = () => {
    settings.callBackClose && settings.callBackClose();
    setOpen(false);
  };

  useEffect(() => {
    if (window && !window.FeedBackKoleso) {
      window.FeedBackKoleso = {
        open: handlerOpen,
        close: handlerClose,
        options: Object.keys(keyOptions),
      };
    }
  }, []);

  return (
    <Modal
      isOpen={open}
      classNameOverlay={classNames({
        [styles.NoBackground]: !settings.isBackground,
      })}
      onClose={handlerClose}
      closeOnOverlayClick
      isWrapperContainer={false}
    >
      <FeedBackGlobal.Switch settings={settings} setOpen={setOpen} handlerClose={handlerClose} />
    </Modal>
  );
};

FeedBackGlobal.Switch = function Switch({ settings, setOpen, handlerClose }) {
  switch (settings.template) {
    case TemplateFeedback.Primary:
      return <FeedBackAsync settings={settings} handlerClose={handlerClose} />;
    case TemplateFeedback.Auto:
      return <FeedBackAutoAsync settings={settings} handlerClose={handlerClose} />;
    case TemplateFeedback.Battery:
      return <FeedBackBatteryAsync settings={settings} handlerClose={handlerClose} />;
    default:
      return null;
  }
};
